import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FileService } from 'src/app/services/file/file.service';
import { SwalService } from 'src/app/services/swal/swal.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { GalleryImagesStoreService } from 'src/app/stores/gallery-images-store/gallery-images-store.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.sass']
})
export class GalleryComponent implements OnInit, OnDestroy {
  dataServiceSub: Subscription;
  currLoc;
  photoProgress = -1;
  fileServiceSub: Subscription;
  photos: Array<any>;
  files: Array<any>;
  videos: Array<any>;
  errorMsg

  selectedIdToDelete: string[] = []
  isAllCheckboxIndeterminate = false
  _allSelectedFiles: any = 0;
  _uploadedSelectedFiles: any = 0;

  constructor(
    private fileService: FileService,
    private swalService: SwalService,
    private toastr: ToastrService,
    private _t: TranslateService,
    private locationStore: LocationStoreService,
    private galleryImagesStore: GalleryImagesStoreService,
    private spinner: NgxSpinnerService
  ) {
    this.dataServiceSub = this.locationStore.currLocation$.subscribe(res => {
      if (res.id) this.currLoc = res
    })
  }

  ngOnInit(): void {
    this.photos = [];
    this.files = [];
    this.videos = [];
    this.dataServiceSub = this.locationStore.currLocation$.subscribe(res => {
      if (res.id) {
        this.currLoc = res
        this.refreshFiles();
      }
    })
  }

  ngOnDestroy() {
    this.dataServiceSub.unsubscribe()
    if (this.fileServiceSub) this.fileServiceSub.unsubscribe()
  }

  async onPhotosSelected(files, type: string) {
    this.errorMsg = []
    const now = new Date()
    let assets
    switch (type) {
      case 'image':
        assets = this.photos
        break;
      case 'video':
        assets = this.videos
        break;
      default:
        assets = this.files
        break;
    }
    this._allSelectedFiles = files.length
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i)
      if (type === 'image' && file.type.split('/')[0] !== type) {
        this.errorMsg.push({filename: file.name, type: file.type})
        continue
      }
      const asset = {
        status: 'Queueing',
        created_at: now,
        file_type: type,
        filename: file.name,
        url: 'https://media2.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif',
        file: file
      }
      assets.splice(0, 0, asset)
    }

    if (this.errorMsg.length > 0) {
      this.toastr.warning(
        `<ul>${this.errorMsg.reduce((acc, i) => {
          return acc + `<li><strong>Filename</strong>: ${i.filename}</br> <strong>Filetype</strong>: ${i.type}</li>`;
        }, '')}</ul>`,
        this._t.instant(
          'These files cannot be upload due to invalid file type:'
        ),
        {
          enableHtml: true,
          timeOut: 7000
        }
      );
    }

    let progress = 1

    for (let i = 0; i < assets.length; i++) {
      if (assets[i].status == 'Queueing') {
        this.photoProgress = progress / files.length * 100
        assets[i].status = 'Uploading'
        assets[i].url = 'https://media2.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif'
        try {
          const res = await this.uploadPhoto(assets[i], type)
          assets[i] = res[0]
          assets[i].status = null
          progress++
          this._uploadedSelectedFiles++
        } catch (error) {
          const msg = error.message
          console.log(error)
          this.toastr.error(this._t.instant(msg), this._t.instant('Error'));
        }
      }
    }

    this.photoProgress = -1
    this._allSelectedFiles = 0
    this._uploadedSelectedFiles = 0
    this.refreshFiles();
  }

  async uploadPhoto(file, type: string) {
    const formData = new FormData()
    formData.append(`${type}s`, file.file)
    formData.append('location', this.currLoc.id)
    return new Promise((resolve, reject) => {
      this.fileService.create(formData).subscribe(
        (res) => {
          
          return resolve(res)
        },
        ({error}) => {
          return reject(error)
        })
    });
  }

  onDelete(photo) {
    this.swalService.confirmDialog((swalRes) => {
      this.fileService.remove(photo.id).subscribe(
        (res) => {
          const undoMsg = this._t.instant('Tap HERE to undo')
          this.toastr
            .info(undoMsg, '', {
              progressBar: true,
              timeOut: 7000,
              enableHtml: true,
            })
            .onTap.pipe(take(1))
            .subscribe(() => {
              this.fileService.restore(photo.id).subscribe();
              this.refreshFiles();
            });
          this.refreshFiles();
          swalRes();
        }, (error) => {
          
        }
      )
    });
  }

  refreshFiles() {
    this.fileServiceSub = this.fileService.findAll([
      { key: 'filtered[0][key]', val: 'location' },
      { key: 'filtered[0][val]', val: this.currLoc.id }
    ]).subscribe(res => {
      this.photos = res.data.filter(i => i.tag === 'images')
      this.files = res.data.filter(i => i.tag === 'files')
      this.videos = res.data.filter(i => i.tag === 'videos')
      this.galleryImagesStore.galleryImages$.next([...this.photos, ...this.videos])
    })
  }

  onChangeAllCheckbox(event) {
    this.isAllCheckboxIndeterminate = false
    if (event.target.checked) {
      this.selectedIdToDelete = this.photos.map(i => i.id)
    } else {
      this.selectedIdToDelete = []
    }
  }
  
  onChangeSelectedCheckbox(event, id) {
    event.preventDefault()
    this.isAllCheckboxIndeterminate = true
    if (event.target.checked) {
      this.selectedIdToDelete.push(id)
    } else {
      this.selectedIdToDelete.splice(this.selectedIdToDelete.indexOf(id),1)
    }
  }

  onDeleteSelected() {
    console.log(this.selectedIdToDelete)
    this.swalService.confirmDialog((swalRes) => {
      this.fileService.removeMany(this.selectedIdToDelete).subscribe(
        (res) => {
          this.isAllCheckboxIndeterminate = false
          this.refreshFiles();
          swalRes();
        }, (error) => {
          
        }
      )
    });
  }
}
